export default __webpack_public_path__ + "static/media/UPRCT_image_interface.2a7c1d55.png";